module.exports = {"red":"#F44A06","orange":"#FDAE1B","yellow":"#FBDA15","blue":"#313F4F"}


//////////////////
// WEBPACK FOOTER
// ./src/data/colors.yaml
// module id = 105
// module chunks = 35783957827783 114276838955818